export const HIDDEN_VALIDATION_KEYS = new Set(['pattern', 'items', 'value']);

export const AUTHOR_TYPE_KIND = 'authorType';

export const AUTHOR_TYPE_HIDDEN_VALIDATION_KEYS = new Set([
  'min',
  'max',
  'minLength',
  'maxLength'
]);

export const TITLE_CHARACTER_LIMIT = 500;
export const SUBTITLE_CHARACTER_LIMIT = 1000;
export const HELP_TEXT_CHARACTER_LIMIT = 500;
export const CONTENT_CHARACTER_LIMIT = 1000;
